import React from 'react';

import { Settings } from 'screens/shared';

import GasTransOil from './GasTransOil/GasTransOil';
import GasEngineOil from './GasEngineOil/GasEngineOil';
import CalibrateEngineSpeed from './CalibrateEngineSpeed/CalibrateEngineSpeed';

const GasSettings = () => {
  const components = {
    transOil: {
      name: GasTransOil,
      route: 'trans-oil',
      actions: ['resetValue']
    },
    engineOil: {
      name: GasEngineOil,
      route: 'engine-oil',
      actions: ['resetValue']
    },
    calibrateEngineSpeed: {
      name: CalibrateEngineSpeed,
      route: 'calibrate-engine-speed'
    }
  };

  return <Settings components={components} />;
};

export default GasSettings;



// WEBPACK FOOTER //
// ./src/screens/Gas/GasSettings/GasSettings.js